var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import ArrowNarrowUpSvg from './arrow-narrow-up.icon.svg';
export const ArrowNarrowUpIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: ArrowNarrowUpSvg }));
_react_refresh_temp_1 = ArrowNarrowUpIcon;
$RefreshReg$(_react_refresh_temp_1, "ArrowNarrowUpIcon");
